import React, { useCallback, useEffect, useState } from 'react';
import styles from './CrmEditableField.module.css';
import { GrEdit } from 'react-icons/gr';
import { getFileUrl } from '../../../../axios/requests/filesReq'
import {
    MdOutlineEmail,
    MdOutlinePhone,
    MdContentCopy,
    MdOutlineWhatsapp,
    MdOutlineSms,
} from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { formatDateFromDB } from '../../../../util/functions';
import { Link } from 'react-router-dom';
import { normalizePhone, stripPhoneFormatting } from '../../../../util/functions'
import axios from 'axios';

const CrmEditableField = (props) => {
    const {
        name,
        type,
        label,
        value,
        onClick,
        referenceObj,
        moduleType,
        onFieldAction,
        isEditableField = true,
        mediaTokenData,
        valueLabel,
        isUpdatePermissions
    } = props;
    const [t] = useTranslation('crm');
    const [fileBlobUrl, setFileBlobUrl] = useState('');
    useEffect(() => {// make blob url for files
        if (type !== 'file' || !mediaTokenData?.mediaToken || !referenceObj?._id) return
        const fetchFile = async () => {
            try {
                let fileUrl = getFileUrl(mediaTokenData?.mediaToken, referenceObj?._id)
                const response = await axios.get(fileUrl, { responseType: 'blob' });

                // Convert the blob to a URL
                const blobUrl = URL.createObjectURL(response.data);
                setFileBlobUrl(blobUrl);
            } catch (error) {
                console.log(error)
            }
        };
        fetchFile();

    }, [type, value, mediaTokenData])//mediaTokenData

    useEffect(() => {
        // Cleanup the blob URL when the component unmounts or the file changes
        return () => {
            if (fileBlobUrl) {
                URL.revokeObjectURL(fileBlobUrl);
            }
        };
    }, [fileBlobUrl])

    const handleDocumentOpen = useCallback((e) => {
        e.preventDefault(); // prevent default <a> navigation
        e.stopPropagation()
        window.open(fileBlobUrl, '_blank', 'noopener,noreferrer');
    }, [fileBlobUrl]);

    let toShowValue = value;
    if (type === 'date') toShowValue = formatDateFromDB(value, false, true, false);
    else if (type === 'select') toShowValue=valueLabel || value
    else if (type === 'datetime') toShowValue = formatDateFromDB(value, false, true, true);
    else if (type === 'boolean') toShowValue = value ? t('Yes') : t('No');
    else if (type === 'reference')

        toShowValue = (
            <Link to={`/crm/${moduleType}/records/${referenceObj?._id}`} onClick={(e) => e.stopPropagation()}>
                {value}
            </Link>
        );
    else if (type === 'file') {
        toShowValue = <a href={fileBlobUrl} onClick={handleDocumentOpen} target="_blank" rel="noopener noreferrer">
            {value}
        </a>
    }
    else if (type === 'phone') toShowValue = stripPhoneFormatting(normalizePhone(value))

    const onActionHandler = useCallback((action) => (e) => {
        e.stopPropagation();
        if (action === 'Edit' && isEditableField) return onClick?.();
        onFieldAction?.({ action, name, value, type });
    }, [name, value, type, isEditableField])

    return (
        <div onClick={isEditableField ? onClick : () => { }} className={`${styles['field-container']} ${type === 'textarea' ? styles['field-container--textarea'] : ''}`}>
            <div className={styles['field-label']}>{label}</div>
            <div className={`${styles['field-value']} ${type === 'textarea' ? styles['field-value--multiline'] : ''}`}>{toShowValue}</div>

            <div className={styles['field-btn-group']}>
                {type === 'email' && value && (
                    <button className={`${styles['icon-btn']} ${styles['hover-only']}`}
                        onClick={onActionHandler('mail')}>
                        <MdOutlineEmail />
                    </button>
                )}

                {type === 'phone' && value && (
                    <>
                        <button className={`${styles['icon-btn']} ${styles['hover-only']}`}
                            onClick={onActionHandler('call')}>
                            <MdOutlinePhone />
                        </button>
                        <button className={`${styles['icon-btn']} ${styles['hover-only']}`}
                            onClick={onActionHandler('whatsapp')}>
                            <MdOutlineWhatsapp />
                        </button>
                        <button className={`${styles['icon-btn']} ${styles['hover-only']}`}
                            onClick={onActionHandler('sms')}>
                            <MdOutlineSms />
                        </button>
                    </>
                )}

                <button className={`${styles['icon-btn']} ${styles['hover-only']}`}
                    onClick={onActionHandler('copy')}>
                    <MdContentCopy />
                </button>

                {isUpdatePermissions && isEditableField && <button className={styles['icon-btn']} onClick={onActionHandler('Edit')}>
                    <GrEdit />
                </button>}
            </div>
        </div>
    );
};

export default CrmEditableField;
